module.exports = __webpack_public_path__ + "img/row-charging-end.83de567f.png";